import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MessageBarService } from '@softline/ui-core';
import { SOFTLINE_CONST_LAGER_ABC_ANALYSIS_CONFIG_KEY } from '../abc-analysis.shared';
import { AbcAnalysisService } from '../services/abc-analysis.service';

export const configurationGuard: CanActivateFn = async () => {
  const abcAnalysisService = inject(AbcAnalysisService);
  const router = inject(Router);
  const messageBarService = inject(MessageBarService);
  const configuration = abcAnalysisService.loadConfiguration(
    SOFTLINE_CONST_LAGER_ABC_ANALYSIS_CONFIG_KEY
  );
  if (!configuration) {
    const configurations = await abcAnalysisService.getConfigurations();
    if (configurations.length === 1) {
      abcAnalysisService.saveConfiguration(
        SOFTLINE_CONST_LAGER_ABC_ANALYSIS_CONFIG_KEY,
        configurations[0]
      );
    } else if (configurations.length > 1) {
      messageBarService.error('#ABC_ANALYSIS.GUARD.MULTI_CONFIG');
      router.navigate(['/abc-analysis/configuration']);
      return false;
    } else {
      messageBarService.error('#ABC_ANALYSIS.GUARD.NO_CONFIG');
      router.navigate(['/abc-analysis/configuration']);
      return false;
    }
  }
  return true;
};
